/**
 * TypeScript types for Conjunction Data Messages (CDMs).
 *
 * These types represent the CDM data that arrives from the backend
 * via tool_complete responses for list_cdms / get_cdm_detail tools.
 */

/**
 * Summary-level CDM data as returned by list_cdms tool.
 * Fields match the backend CDM query result shape.
 */
export interface CdmSummary {
  cdm_id: string
  sat1_name?: string
  sat2_name?: string
  sat1_norad_id?: number
  sat2_norad_id?: number
  tca: string // ISO datetime string
  miss_distance_m?: number | null
  collision_probability?: number | null
  emergency_reportable?: boolean
  created_at?: string
}

/**
 * Extract CDM summaries from a tool_complete response.
 * Returns null if the response does not contain CDM list data.
 */
export function extractCdmList(
  toolName: string,
  response: Record<string, unknown> | null,
): CdmSummary[] | null {
  if (toolName !== 'list_cdms' || !response) return null

  const cdms = response.cdms
  if (!Array.isArray(cdms) || cdms.length === 0) return null

  return cdms.filter(
    (item): item is CdmSummary =>
      typeof item === 'object' &&
      item !== null &&
      ('cdm_id' in item || 'id' in item || 'CDM_ID' in item),
  ).map((item) => ({
    ...item,
    // Normalize ID field
    cdm_id: String(item.cdm_id || (item as unknown as Record<string, unknown>).id || (item as unknown as Record<string, unknown>).CDM_ID),
  }))
}
